<div class="text-center">
  <p><i class="fa fa-times-circle text-danger fa-3x"></i></p>
  <h3>{{'plan.error' | translate}}</h3>
  <span class="text-muted"><a
    [routerLink]="['/plan']">{{'plan.tryAgain' | translate}}</a> {{'plan.contactSupport' | translate}}</span>
</div>
